"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLocal = getLocal;
exports.removeLocal = removeLocal;
exports.setLocal = setLocal;

var _json = require("./json");

var _browser = require("./browser");

function setLocal(key, data) {
  var raw = (0, _json.safeJsonStringify)(data);
  var local = (0, _browser.getLocalStorage)();

  if (local) {
    local.setItem(key, raw);
  }
}

function getLocal(key) {
  var data = null;
  var raw = null;
  var local = (0, _browser.getLocalStorage)();

  if (local) {
    raw = local.getItem(key);
  }

  data = raw ? (0, _json.safeJsonParse)(raw) : raw;
  return data;
}

function removeLocal(key) {
  var local = (0, _browser.getLocalStorage)();

  if (local) {
    local.removeItem(key);
  }
}